import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";

export function CtaBand({ title = "Let's build your unfair advantage.", sub }) {
  return (
    <section className="relative overflow-hidden border-t border-white/10 py-24 lg:py-32">
      <div className="absolute inset-0 grid-bg opacity-30" />
      <div className="absolute left-1/2 top-1/2 h-[380px] w-[620px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-brand/15 blur-[160px]" />
      <div className="relative mx-auto flex max-w-7xl flex-col gap-10 px-4 sm:px-6 lg:flex-row lg:items-end lg:justify-between lg:px-8">
        <Reveal>
          <p className="font-mono text-xs uppercase tracking-[0.25em] text-brand">Next step</p>
          <h2 className="mt-4 max-w-2xl font-display text-4xl font-black uppercase leading-[0.95] tracking-tight text-white sm:text-5xl lg:text-6xl">
            {title}
          </h2>
          {sub && <p className="mt-5 max-w-xl text-base text-muted2 md:text-lg">{sub}</p>}
        </Reveal>
        <Reveal delay={0.15}>
          <Link
            to="/contact"
            data-testid="cta-band-button"
            className="group inline-flex items-center gap-4 rounded-full border border-brand/50 px-8 py-5 font-display text-lg font-bold text-white transition-colors duration-300 hover:bg-brand hover:text-ink active:scale-95"
          >
            Start a Project
            <ArrowUpRight className="h-6 w-6 text-brand transition-colors duration-300 group-hover:text-ink" />
          </Link>
        </Reveal>
      </div>
    </section>
  );
}
